<script>
  import moment from 'moment';
  import {Chart,ArcElement,LineElement,BarElement,PointElement,BarController,BubbleController,DoughnutController,LineController,PieController,PolarAreaController,RadarController,ScatterController,CategoryScale,LinearScale,LogarithmicScale,RadialLinearScale,TimeScale,TimeSeriesScale,Decimation,Filler,Legend,Title,Tooltip} from 'chart.js';
  import sentimentColourScale from "./sentimentColourScale"

  Chart.register(ArcElement,LineElement,BarElement,PointElement,BarController,BubbleController,DoughnutController,LineController,PieController,PolarAreaController,RadarController,ScatterController,CategoryScale,LinearScale,LogarithmicScale,RadialLinearScale,TimeScale,TimeSeriesScale,Decimation,Filler,  Legend,Title,Tooltip);

  export let boardInstances = []
  export let moods =[]

  export let canvasName = 'sentimentChart'
  export let zoom = false
  export let chartTitle = ''

  var windowsOS = navigator.appVersion.indexOf('Win') != -1;
  var chartDataSet =[]
  var chartLabels
  var chartData ={}
  var config = {
    options: {
      responsive: true,
      maintainAspectRatio: true
    }
  }
  var lineColour
  var myChart
  var gradient;

  var chartData = {
    labels: chartLabels,
    datasets: [{
      borderColor: gradient,
      pointBorderColor: gradient,
      pointBackgroundColor: gradient,
      fill: false,
      data: chartDataSet,
      spanGaps: true,
    }]
  };

  function createChart() {
    if(myChart) {
      myChart.destroy()
    }
    // if(document.getElementById('sentimentChart')) {
    if(document.getElementById(canvasName)) {
      myChart = new Chart(
      // document.getElementById('sentimentChart'),
      document.getElementById(canvasName),
      config
    )
    } else {
      //console.log('Canvas not available')
      setTimeout(createChart, 1000)
    };
  }


  var chartDataSet; 
  var chartLabels;
  var filteredInstances;
  $:{
    filteredInstances = boardInstances.filter(item => item.id !== 'placeholder-today');
    chartDataSet = filteredInstances.slice().reverse().map(x => x.avg_sentiment_score)
    chartLabels = boardInstances.slice().reverse().map(x => moment(x.date).format('DD MMM'))
    config = {
     type: 'line',
     data: chartData,
       plugins: [{
         beforeDraw: function(chart, options) {
          let fontSize;
          if (windowsOS) {
            fontSize = zoom ? '22': '18';
         } else {
            fontSize = zoom ? '32': '22';
          }
           chart.ctx.font=  fontSize + "px serif"
           // var sadX = chart.scales['x'].getPixelForTick(0) - fontSize - 6
           // var sadX = chart.scales['x'].getPixelForTick(0) - fontSize - 8
           var sadX = chart.scales['x'].getPixelForTick(0) - fontSize + 36
           // var sadY = chart.scales['y'].getPixelForTick(0)
           var sadY = chart.scales['y'].getPixelForTick(0) - 12
          if(zoom) chart.ctx.fillText('🙁', sadX, sadY)

           // var happyX = chart.scales['x'].getPixelForTick(0) - fontSize - 6
           // var happyX = chart.scales['x'].getPixelForTick(0) - fontSize - 8
           var happyX = chart.scales['x'].getPixelForTick(0) - fontSize + 36
           // var happyY = chart.scales['y'].getPixelForTick(3)
           var happyY = chart.scales['y'].getPixelForValue(1) + 20
           if (zoom) chart.ctx.fillText('😃',happyX, happyY) ;

           if (!zoom) {
             // var zoomX = chart.width - fontSize - 4
             // var zoomY = chart.scales['y'].getPixelForTick(0)-8
             // chart.ctx.fillText('🔍',zoomX, zoomY) ;
         }
           chart.ctx.save(); 
         }
       }],
     options: {
         events: ['click'],
            interaction: {
                mode: 'nearest',
            axis: 'x'
            },
       layout: {
          padding: {
              Xleft: 24
          }
      },
       elements: {
         point: {
            pointRadius: (ctx) => {
              const index = ctx.dataIndex;
              const value = ctx.dataset.data[index];
              const isLast = index === ctx.dataset.data.length - 1;
              if (zoom) {
                return isLast ? 4 : 4;
              } else {
                // return isLast ? 1.9 : 1.5;
                return isLast ? 1.4 : 1.4;
              }              
            },
            pointStyle: (ctx) => {
              const index = ctx.dataIndex;
              const value = ctx.dataset.data[index];
              const isLast = index === ctx.dataset.data.length - 1;
              return isLast ? 'circle' : 'circle';
            },
            pointRotation: (ctx) => {
              const index = ctx.dataIndex;
              const isLast = index === ctx.dataset.data.length - 1;
              if (isLast && index > 0) {
                const y2 = ctx.dataset.data[index];
                const y1 = ctx.dataset.data[index - 1];
                const x2 = index;
                const x1 = index - 1;
                const slope = (y2 - y1) / (x2 - x1);
                const angle = Math.atan(slope) * (180 / Math.PI);
                // Adjust the angle for the rotation of the 'triangle' point style
                // and scale it to match the visual slope of the line
                return (angle - 90) / 4.2;  // experiment with different values instead of 2
              }
              return 0;
            }

         }
       },
       animation: {
         duration: zoom ? 100 : 200
       },
       responsive: true,
       scales: {
              y: {
                  min:-1,
                  max:1,
                  grid:{
                    drawBorder: zoom ? true : false,
                    borderDash: [4, 4],
                    lineWidth: 1.5,
                    color: function(context) {
                      if (context.tick.value  == 0. ) {
                         // return '#255991';
                         return '#34c7c8';
                         // return '#d2d2d2';
                      }
                   },
                 },
                 ticks:{
                   display:false
                  //  font: {
                  //     size: 12
                  //   },
                  //  callback: function(value, index, values) {
                  //    if (value  < 0) return '🙁'
                  //    else if (value == 0) return ' ';
                  //    else if (value > 0 ) return '😀'
                  // },
               },
               display: true
              },
              x: {
                  grid:{display:zoom ? true : false, drawOnChartArea: false, color: '#34c7c8',},
                  ticks:{
                      display: true,
                    display: zoom ? true : false,
                    color: '#34c7c8',
                   font: {
                    size: windowsOS ? 14: 18
                    }
                  },
                  // display: false,
                  display: zoom ? true : false,
                  fontColor: '#255991'
              }},
       plugins: {
         legend: {display: false},
         title: {display: zoom ? true : false, text: zoom ?  chartTitle : 'Team Mood', color: '#255991' , font:{size: zoom ? 20 : 14}},
         tooltip: {
            intersect: false,
            display: zoom ? true: false,
            enabled: zoom ? true: false,
            titleColor: '#255991',
            titleFont: {size: 20},
            bodyFont: {size: 24},
            displayColors: false,
            backgroundColor: '#fafafa',
            borderColor:'#34c7c8',
            borderWidth: 1,
            callbacks: {
             label:function(tooltipItem) {
                let instanceID = boardInstances.slice().reverse()[tooltipItem.dataIndex].id;
                var moodsThisDate = moods.filter(x => x.board_instance_id == instanceID);
                return moodsThisDate.map(x => x.mood.join('')).join('')
            },
             footer: toolTipFooter,
           }
         }
       }
     }
   };

   if(myChart){
    gradient = getGradient(chartDataSet);
     myChart.data.datasets[0].borderColor = gradient;
     myChart.data.datasets[0].data = chartDataSet;
     myChart.data.datasets[0].lineTension = 0.4
     myChart.data.datasets[0].borderWidth = zoom ? 4.0 : 3.4
     myChart.data.labels = chartLabels
     // myChart.options.interaction.axis = 'xy';
     // myChart.options.interaction.mode = 'nearest';
     // Chart.defaults.borderColor = '#25/5991'
     myChart.update()

     /* Add gradient to debug */
     // myChart.canvas.getContext('2d').fillStyle = gradient;
     // myChart.canvas.getContext('2d').fillRect(myChart.chartArea.left, 20, myChart.chartArea.right, 25)

      } else {
       createChart()
     }

   }  // End of reactive function


   let width, height;

    // function getGradient(ctx, chartArea, chartDataSet) {
    function getGradient(chartDataSet) {
      if(!document.getElementById('sentimentChart')) {
       return;
      } 
     var ctx = document.getElementById('sentimentChart').getContext("2d");
     var chartArea = myChart.chartArea
     const chartWidth = chartArea.right - chartArea.left;
     const chartHeight = chartArea.bottom - chartArea.top;

     height = chartHeight;
     gradient = ctx.createLinearGradient(chartArea.left, 0, chartArea.right,0);

     var increment = 1 / chartDataSet.length;
     var gradientOffSet =  0
     // var gradientOffSet =  increment // include 20 px for padding
     // console.log('offset: ' + gradientOffSet)
     chartDataSet.forEach(element => {
       if (element) {
          var color = getSentimentColourCode(element)
          gradient.addColorStop(gradientOffSet, color);
          /* Debugging code
          console.log('offset: ' + gradientOffSet + ', value: ' + element + ', color: ' + color);
          console.log('%c' + color, 'background: '+ color);
          */
        }
        gradientOffSet += increment
     });

     return gradient;
   }

   function getSentimentColourCode (sentiment) {
     if (Number.parseFloat(sentiment)) {
       var sentimentFixed = Number.parseFloat(sentiment).toFixed(1)
       // console.log('sentimentFixed:' + sentimentFixed)
       return sentimentColourScale.filter(a => a.sentiment == sentimentFixed)[0].colour_code
     }
     else {
       return 'green'
     }
   }

   const toolTipFooter = (tooltipItems) => {
    return ''
  };

</script>
<canvas id="{canvasName}"></canvas>
